export const SCRIBENOTE_PRO_FEATURES = [
  "Most advanced AI and transcription models for more accurate notes",
  "Custom Adaptive Templates",
  "Scribephone (direct calling)",
  "AI Writing Assistant",
  "Client Summaries",
  "PIMS integrations",
  "Priority Human Support",
  "Multilingual Transcription",
];
